import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "./actions";
import CONSTANTS from "./CONSTANTS";
import { toastError } from "../helpers/toastError";

const callRequestUrl = "/services/clientinterest/";
const authUrl = "/services/auth/";

export function* getSendCallRequest() {
  yield takeLatest(CONSTANTS.GET_SEND_CALL_REQUEST, function* (action) {
    yield put(actions.setCallRequestHasBeenSent(undefined));
    try {
      const headers = {
        Authorization: `Bearer ${action.payload.token}`,
      };

      const url = `${callRequestUrl}AddClientInterest`;

      const res = yield window.mainAxios.post(url, action?.payload.data, {
        headers,
      });

      const error = {
        exceptionCode: res.data.exceptionCode,
        exceptionMessage: res.data.exceptionMessage,
      };
      if (!res.data.success) throw error;
      yield put(actions.setCallRequestHasBeenSent(true));
      yield put(actions.setServiceToken(""));
    } catch (e) {
      yield toastError("errors.failedToSendInformation", { autoClose: true });
      yield put(actions.setCallRequestHasBeenSent(false));
      yield put(actions.setServiceToken(""));
    } finally {
      yield put(actions.setCallRequestLoading(false));
    }
  });
}

export function* getServiceToken() {
  yield takeLatest(CONSTANTS.GET_SERVICE_TOKEN, function* (action) {
    yield put(actions.setCallRequestLoading(true));
    yield put(actions.setServiceToken(""));
    try {
      const url = `${authUrl}GetServiceToken/${process.env.REACT_APP_GET_SERVICE_TOKEN_ID}`;

      const res = yield window.mainAxios.get(url);

      const error = {
        exceptionCode: res.data.exceptionCode,
        exceptionMessage: res.data.exceptionMessage,
      };
      if (!res.data.success) throw error;
      yield put(actions.setServiceToken(res?.data?.data?.token));
    } catch (e) {
      yield toastError("errors.failedToSendInformation", { autoClose: true });
      yield put(actions.setServiceToken(null));
      yield put(actions.setCallRequestLoading(false));
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getSendCallRequest), fork(getServiceToken)]);
}
